import axios from 'axios';
import Chocolat from 'chocolat';

function addSelectOption(selectElement, id, text) {
    const option = document.createElement('option');
    option.value = id;
    option.text = text;
    selectElement.add(option);
}

window.addEventListener('scroll', () => {
    const { scrollTop } = (document.documentElement || document.body.parentNode || document.body);
    if (scrollTop > 60) {
        document.getElementsByTagName('body')[0].classList.add('scrolled');
    } else {
        document.getElementsByTagName('body')[0].classList.remove('scrolled');
    }
});

if (document.querySelector('.video-bg') || document.querySelector('.photo-bg')) {
    document.getElementsByTagName('body')[0].classList.add('with-fullscreen-bg');
}

const searchCountry = document.getElementById('search-country');
const searchRegion = document.getElementById('search-region');

if (searchCountry && searchRegion) {
    document.addEventListener('change', (e) => {
        if (e.target === searchCountry) {
            Array.from(searchRegion.options).forEach((region) => {
                if (region.value !== '') {
                    region.remove();
                }
            });
            axios.get(`/api/regions?q=${e.target.value}`).then(({data}) => {
                data.forEach((region) => {
                    addSelectOption(searchRegion, region.id, region.text);
                });
            });
        }
    });
}

Chocolat(document.querySelectorAll('.chocolat-image'), {
    //imageSize: 'contain',
});
